export const emailRegex = /^[\w.-]+@[a-zA-Z_-]+?(?:\.[a-zA-Z]{2,})+$/;

export const phoneRegex = /^\+?\d+(\s+\d+)*$/;

export function validateEmail(value: string) {
	return emailRegex.test(value);
}

export function validatePhone (value : string){
	return phoneRegex.test(value)
}
